<div class="flex flex-col gap-4">
	<h4 class="font-medium text-lg m-0">Additional Settings</h4>

	<ui-checkbox
		label="Fee subject to HST"
		[ngModel]="defaultIdvSettingsSignal()?.hst"
		(ngModelChange)="setHst($event)"
		[testHook]="testHooks.FeeSubjectToHstCheckbox"
	/>

	<div class="flex items-center gap-3 flex-nowrap">
		<ui-checkbox
			label="Require secondary ID"
			[ngModel]="treefortSettingsSignal()?.secondaryIdRequired"
			(ngModelChange)="setSecondaryIdRequired($event)"
			data-intercom-target="treefort-require-secondary-id-setting"
			[testHook]="testHooks.RequireSecondaryIdCheckbox"
		/>
		<i-tabler
			class="h-4 w-4 text-gray-900"
			name="info-square-rounded"
			matTooltip="Most lenders require a secondary ID. Always confirm ID requirements with the LSO."
		/>
	</div>

	<div class="flex items-center gap-3 flex-nowrap">
		<ui-checkbox
			label="Require financial institution login"
			[ngModel]="treefortSettingsSignal()?.financialInstitutionLoginRequired"
			(ngModelChange)="setReqFinancialInstLogin($event)"
			data-intercom-target="treefort-require-financial-institution-setting"
			[testHook]="testHooks.RequireFinancialInstitutionLoginCheckbox"
		/>
		<i-tabler
			class="h-4 w-4 text-gray-900"
			name="info-square-rounded"
			matTooltip="Client must confirm their primary financial institution. Note this info is kept private between client and institution."
		/>
	</div>

	<div class="flex items-center gap-3 flex-nowrap">
		<ui-checkbox
			label="Require advanced AML screening"
			[ngModel]="treefortSettingsSignal()?.advancedAMLScreeningRequired"
			(ngModelChange)="setReqAdvAmlScreening($event)"
			data-intercom-target="treefort-require-advanced-aml-setting"
			[testHook]="testHooks.RequireAdvancedAmlScreeningCheckbox"
		/>
		<i-tabler
			class="h-4 w-4 text-gray-900"
			name="info-square-rounded"
			matTooltip="Anti-Money Laundering uses global watch, sanction, and politically exposed person (PEP) lists to ensure compliance."
		/>
	</div>
</div>
